import './Spinner.css';

export const Spinner = () => {
    
    return (
        <div className="spinner">
            <div className="mask">
                <div className="maskedCircle"/>
            </div>
        </div>
    )
    
}
export default Spinner;